import { render, staticRenderFns } from "./ListWheels.vue?vue&type=template&id=5bc4e4a1&"
import script from "./ListWheels.vue?vue&type=script&lang=js&"
export * from "./ListWheels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports